interface IChipLabelProps {
  label: string;
  onResetClick: () => void;
}
export default function ChipLabel(props: IChipLabelProps) {
  const { label, onResetClick } = props;

  return (
    <span className="septima-search-chip-label">
      <span className="septima-search-chip-label-title" title={label}>
        {label}
      </span>
      <span
        className="septima-search-chip-label-reset"
        onClick={onResetClick}
      />
    </span>
  );
}
